export const BenefitEmpty = () => (
    <svg
        width="132"
        height="132"
        viewBox="0 0 132 132"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22.2442 101.548C23.0358 101.76 23.9185 101.315 24.1528 100.44C24.3871 99.5661 23.9243 98.7606 23.0536 98.5273C22.2621 98.3152 21.3793 98.7602 21.145 99.6346C20.8894 100.588 21.4527 101.336 22.2442 101.548Z"
            fill="#DFDFDF"
        />
        <path
            d="M88.9752 38.6857L107.431 70.8076C109.745 74.8354 108.382 79.9225 104.364 82.2536L54.4609 111.138C52.8537 112.071 50.9785 112.42 49.2524 112.213C46.7135 111.874 44.3723 110.48 43.063 108.084L24.6075 75.9623C22.2933 71.9344 23.6564 66.8473 27.6744 64.5162L77.4981 35.6104C79.4067 34.5031 81.6776 34.2597 83.7569 34.7316C85.894 35.3043 87.739 36.6506 88.9752 38.6857Z"
            fill="url(#paint0_linear_296_25965)"
        />
        <path
            d="M88.9752 38.6857L107.431 70.8076C109.745 74.8354 108.382 79.9225 104.364 82.2536L54.4609 111.138C52.8537 112.071 50.9785 112.42 49.2524 112.213C46.7135 111.874 44.3723 110.48 43.063 108.084L24.6075 75.9623C22.2933 71.9344 23.6564 66.8473 27.6744 64.5162L77.4981 35.6104C79.4067 34.5031 81.6776 34.2597 83.7569 34.7316C85.894 35.3043 87.739 36.6506 88.9752 38.6857Z"
            fill="#F3F3F3"
        />
        <path
            d="M95.1078 49.3594L98.1162 54.5956C98.095 54.6751 98.0158 54.6539 97.9154 54.7121L82.3242 63.8247L92.8749 82.0718L95.7098 87.0059C95.7676 87.1065 95.7676 87.1065 95.8255 87.2072L90.602 90.2377C90.5229 90.2165 90.5442 90.137 90.465 90.1158L79.893 71.9482L76.979 66.9929L33.785 92.0523L30.7188 86.7155L73.9127 61.656L63.6146 43.7322L68.9385 40.6435L79.337 58.509L95.0074 49.4177C94.9282 49.3965 95.0074 49.4177 95.1078 49.3594Z"
            fill="#C0C0C0"
        />
        <path
            d="M96.6339 77.5413L91.8879 77.2068L91.2766 81.3879L91.1701 81.7853L90.6434 81.2182L78.6656 68.2967L75.7627 77.2309L74.0556 82.6519L71.7933 79.0639L67.4707 80.6319L69.0347 75.4282L70.4283 70.8604L86.0596 65.0811L96.6339 77.5413Z"
            fill="#D2D2D2"
        />
        <path
            d="M63.7602 82.4492L42.8664 94.571C42.3641 94.8624 42.1937 95.4982 42.483 96.0017C42.7723 96.5052 43.4055 96.6749 43.9077 96.3835L64.8015 84.2617C65.3038 83.9703 65.4742 83.3344 65.1849 82.831C64.8956 82.3275 64.2624 82.1578 63.7602 82.4492Z"
            fill="white"
        />
        <path
            d="M60.0777 90.4929L54.6534 93.6399C54.1511 93.9313 53.9807 94.5672 54.27 95.0707C54.5593 95.5741 55.1925 95.7438 55.6948 95.4524L61.1191 92.3054C61.6214 92.014 61.7918 91.3781 61.5025 90.8747C61.2132 90.3712 60.58 90.2015 60.0777 90.4929Z"
            fill="white"
        />
        <path
            d="M51.8194 95.3511L45.491 99.0226C44.9887 99.314 44.8184 99.9499 45.1076 100.453C45.3969 100.957 46.0301 101.126 46.5324 100.835L52.8608 97.1636C53.363 96.8722 53.5334 96.2363 53.2442 95.7328C52.8757 95.2082 52.3217 95.0597 51.8194 95.3511Z"
            fill="white"
        />
        <path
            d="M72.0736 59.9706L76.9811 61.2855L79.5756 67.4331L76.8542 68.4078L69.4911 74.3578C67.8779 75.6295 65.4667 74.813 64.9855 72.8098L62.3598 61.7126C61.8998 59.6299 63.7626 57.7436 65.8206 58.2951L66.1372 58.3799"
            fill="#DDDDDD"
        />
        <path
            d="M79.1952 67.5869L82.0049 67.2322L91.2353 69.1943C93.2354 69.645 95.0769 67.8382 94.6169 65.7555L91.9912 54.6584C91.5313 52.5757 88.9405 51.7963 87.3851 53.1686L78.7985 60.8355L79.1952 67.5869Z"
            fill="#DDDDDD"
        />
        <g opacity="0.3">
            <path
                opacity="0.3"
                d="M77.8102 68.3232L76.97 68.6092L77.0705 68.551L71.908 72.6201C71.0405 73.3248 70.1943 73.95 69.3268 74.6546C68.4015 75.2586 67.129 75.2584 66.2065 74.5853L66.2278 74.5058C67.1716 75.0995 68.3649 75.0784 69.2111 74.4533C70.0573 73.8281 70.8457 73.1022 71.7132 72.3975L76.7386 68.2065L77.5788 67.9204L77.8102 68.3232Z"
                fill="#A8B2C3"
            />
        </g>
        <g opacity="0.3">
            <path
                opacity="0.3"
                d="M80.495 67.1683L81.9896 66.9724L88.2061 68.4678L91.3144 69.2154C92.3647 69.4116 93.5062 68.9508 94.0784 68.0818C93.5062 68.9508 92.3434 69.4911 91.2718 69.3744L88.121 68.7857L81.8406 67.5288L81.9197 67.5501L80.5468 67.6081L80.495 67.1683Z"
                fill="#A8B2C3"
            />
        </g>
        <path
            d="M74.1352 63.6752C73.7817 61.195 75.2122 59.0225 77.2091 58.5353C79.4861 57.9527 81.9157 59.9668 82.6589 62.8921C83.4021 65.8175 82.0387 68.6895 79.7617 69.2721C78.124 69.6852 76.3886 68.8794 75.3838 67.2471C74.5891 66.097 74.385 65.2756 74.1352 63.6752Z"
            fill="white"
        />
        <path
            d="M75.6595 31.263C75.422 31.1994 75.2059 31.0563 75.0901 30.8549L74.8374 30.5316C74.8374 30.5316 74.7583 30.5104 74.7796 30.4309L71.424 24.5906C71.1348 24.0871 71.3052 23.4512 71.8074 23.1598C72.3097 22.8684 72.9429 23.0381 73.2322 23.5416L76.7613 29.684C77.0718 30.108 76.9806 30.7651 76.5362 31.1572C76.2561 31.2525 75.9761 31.3479 75.6595 31.263Z"
            fill="#D0D0D0"
        />
        <path
            d="M86.0938 23.6653C85.5398 23.5168 85.1926 22.9127 85.3417 22.3562L87.1521 15.5999C87.3012 15.0435 87.9039 14.6938 88.4579 14.8423C89.012 14.9907 89.3591 15.5949 89.21 16.1513L87.3784 22.9872C87.2506 23.4641 86.6479 23.8138 86.0938 23.6653Z"
            fill="#D0D0D0"
        />
        <path
            d="M84.2834 30.4216C83.7294 30.2731 83.3822 29.669 83.5313 29.1125L84.3407 26.0921C84.4898 25.5357 85.0925 25.186 85.6465 25.3344C86.2006 25.4829 86.5477 26.0871 86.3986 26.6435L85.5893 29.664C85.4402 30.2204 84.8375 30.5701 84.2834 30.4216Z"
            fill="#D0D0D0"
        />
        <path
            d="M91.9736 34.0157C91.7361 33.952 91.52 33.8089 91.3464 33.5068C91.0572 33.0034 91.2275 32.3675 91.7298 32.0761L96.7523 29.1622C97.2546 28.8708 97.8878 29.0405 98.1771 29.5439C98.4664 30.0474 98.296 30.6833 97.7937 30.9747L92.7712 33.8886C92.549 34.0846 92.2111 34.0793 91.9736 34.0157Z"
            fill="#D0D0D0"
        />
        <path
            d="M49.516 37.1432C49.05 35.3997 46.8976 34.5674 45.4061 35.7012C44.6814 33.9735 42.4012 33.6181 41.1259 34.8951C39.9936 35.9548 40.2282 37.2956 40.9377 38.7636C41.6472 40.2316 42.7159 41.6255 43.3005 42.2933C43.3583 42.394 43.5166 42.4364 43.6749 42.4788C43.8332 42.5212 43.9915 42.5636 44.092 42.5053C44.8317 42.2776 46.5333 41.626 47.9031 40.6299C49.0719 39.7504 49.9455 38.7066 49.516 37.1432Z"
            fill="#D0D0D0"
        />
        <path
            d="M100.48 109.412C100.632 107.579 98.9088 106.095 97.0701 106.624C96.9055 104.706 94.9966 103.598 93.2524 104.408C91.8095 105.044 91.6057 106.438 91.7764 108.017C91.9471 109.596 92.4923 111.361 92.7968 112.124C92.8547 112.225 92.9125 112.326 93.0496 112.448C93.1866 112.569 93.2657 112.591 93.4453 112.554C94.2794 112.607 96.0694 112.575 97.628 112.141C99.1074 111.685 100.313 110.986 100.48 109.412Z"
            fill="#D0D0D0"
        />
        <path
            opacity="0.5"
            d="M68.3981 116.747C67.0159 116.206 65.5091 117.08 65.4424 118.596C64.0176 118.214 62.6844 119.39 62.7973 120.869C62.8949 122.088 63.8599 122.602 65.0472 122.92C66.3137 123.259 67.6866 123.201 68.3837 123.133C68.4629 123.154 68.5633 123.095 68.6638 123.037C68.7642 122.979 68.7855 122.899 68.9073 122.762C69.1568 122.147 69.5189 120.796 69.6222 119.46C69.7621 118.305 69.5427 117.224 68.3981 116.747Z"
            fill="#E8ECF8"
        />
        <path
            opacity="0.5"
            d="M28.1294 52.3702C26.7472 51.8295 25.2405 52.7036 25.1737 54.2192C23.749 53.8375 22.4158 55.0137 22.5286 56.4923C22.7053 57.7323 23.6704 58.2465 24.8577 58.5646C26.1242 58.904 27.4971 58.8459 28.1942 58.7771C28.2734 58.7983 28.3738 58.74 28.4743 58.6818C28.5747 58.6235 28.6965 58.4857 28.7178 58.4062C28.9673 57.7915 29.3294 56.4403 29.4327 55.1049C29.4934 53.9284 29.2741 52.8473 28.1294 52.3702Z"
            fill="#DFDFDF"
        />
        <path
            d="M110.051 44.2478C109.838 42.8275 108.282 41.9847 106.977 42.7423C106.505 41.3379 104.864 40.813 103.695 41.6926C102.727 42.4555 102.788 43.4942 103.144 44.6972C103.501 45.9002 104.274 47.1297 104.642 47.6544C104.7 47.7551 104.779 47.7763 104.916 47.8982C104.995 47.9194 105.154 47.9619 105.254 47.9036C105.872 47.8136 107.251 47.4163 108.435 46.7965C109.44 46.2137 110.228 45.4878 110.051 44.2478Z"
            fill="#DFDFDF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_296_25965"
                x1="48.971"
                y1="111.701"
                x2="82.3349"
                y2="36.9101"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF66A9" />
                <stop offset="1" stopColor="#F53689" />
            </linearGradient>
        </defs>
    </svg>
);
